// extracted by mini-css-extract-plugin
export var deleteIcon = "_mx-5";
export var deleteOption = "_mx-3";
export var divider = "_mx-2";
export var downloadIcon = "_mx-4";
export var drawer = "_mx-0";
export var drawerFooter = "_mx-6";
export var drawerOpen = "_mx-1";
export var highlighted = "_mx-7";
export var lighterHighlight = "_mx-8";